import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import defaultBookImage from "../assets/default-book-image.png";
import {BottomNavigation, BottomNavigationAction, Chip, Fab, Input, Rating, Tooltip} from "@mui/material";
import Modal from "@mui/material/Modal";
import {Fade} from "reactstrap";
import Loading from "./Loading";
import {Chips} from 'primereact/chips';
import {FileUpload} from "primereact/fileupload";

class BookModal extends Component {

    render() {
        // Parent Variables
        let book = this.props.book || null;
        let loadingUpdate = this.props.loadingUpdate || false;
        let editMode = this.props.bookModalEditMode || false;
        let bookModalEditModeSubjects = this.props.bookModalEditModeSubjects || [];

        // Parent Functions
        const showBookModal = this.props.showBookModal;
        const closeBookModal = this.props.closeBookModal;
        const bookModalNavValue = this.props.bookModalNavValue;
        const setBookModalNavValue = this.props.setBookModalNavValue;
        const markAsReading = this.props.markAsReading;
        const markAsNotReading = this.props.markAsNotReading;
        const markCompleted = this.props.markCompleted;
        const openConfirmDialog = this.props.openConfirmDialog;
        const updateRating = this.props.updateRating;
        const setBookModalEditMode = this.props.setBookModalEditMode;
        const saveBookUpdates = this.props.saveBookUpdates;
        const setBookModalEditModeSubjects = this.props.setBookModalEditModeSubjects;
        const recommendBook = this.props.recommendBook;

        const getAuthors = (authors) => {
            if (authors) {
                return authors.join(", ");
            }
            return "Unknown";
        }

        const showUpdateButtons = () => {
            return bookModalNavValue === "update";
        }

        const isReading = (book) => {
            return book.currentlyReading;
        }

        const hasCompleted = (book) => {
            return book.completed;
        }

        return (
            <Modal
                open={showBookModal}
                onClose={closeBookModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className={"book-modal"}
            >
                <div className="book-modal-inner">

                    {loadingUpdate &&
                        <div className="loading-update-container">
                            <Loading/>
                        </div>
                    }

                    <div className="book-modal-close">
                        <button onClick={closeBookModal}>
                            <FontAwesomeIcon icon="times"/>
                        </button>
                    </div>

                    {(book) &&
                        <>
                            <div className="book-details">

                                <div className="image">

                                    {!editMode &&
                                        <div className="rating-and-recommend-container">

                                            {hasCompleted(book) &&
                                                <>
                                                    <div className="recommend"
                                                         onClick={() => {
                                                             recommendBook(book.book);
                                                         }}>
                                                        <Tooltip title="Recommed this book to others">
                                                            <FontAwesomeIcon icon="bullhorn"/>
                                                        </Tooltip>
                                                    </div>
                                                    <div className="rating">
                                                        <Rating
                                                            name="simple-controlled"
                                                            value={book.rating}
                                                            onChange={(event, newValue) => {
                                                                if (!newValue) {
                                                                    newValue = 0;
                                                                }
                                                                updateRating(book.book, newValue);
                                                            }}
                                                        />
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    }

                                    <div className="book-status">
                                        {isReading(book) &&
                                            <Chip label="Reading" className="reading-chip"/>
                                        }

                                        {hasCompleted(book) &&
                                            <Chip label="Completed" className="completed-chip"/>
                                        }
                                    </div>

                                    {book.coverData ?
                                        <img
                                            src={book.coverData}
                                            alt={book.book.title}
                                            width="100%"
                                            height="auto"/>
                                        :
                                        <img
                                            src={defaultBookImage}
                                            alt="Default book cover"
                                            width="100%"
                                            height="auto"/>
                                    }
                                </div>

                                <div className="edit-mode-toggle">
                                    {editMode ?
                                        <Fab size="small" className="edit-mode-toggle-button save" onClick={() => {
                                            setBookModalEditMode(!editMode);
                                            saveBookUpdates(book);
                                            setBookModalEditModeSubjects([]);
                                        }}>
                                            <Tooltip title="Save changes">
                                                <FontAwesomeIcon icon="check"/>
                                            </Tooltip>
                                        </Fab>
                                        :
                                        <Fab size="small" className="edit-mode-toggle-button edit" onClick={() => {
                                            setBookModalEditMode(!editMode);
                                            setBookModalEditModeSubjects(book.book.subject);
                                        }}>
                                            <Tooltip title="Edit this books details">
                                                <FontAwesomeIcon icon="pencil-alt"/>
                                            </Tooltip>
                                        </Fab>
                                    }
                                </div>

                                <div className="info">
                                    <div className="title">
                                        {editMode ?
                                            <Input
                                                defaultValue={book.book.title}
                                                fullWidth
                                                className="title-input"
                                                onChange={(event) => {
                                                    book.book.title = event.target.value;
                                                }}
                                            />
                                            :
                                            <span>{book.book.title}</span>
                                        }
                                    </div>
                                    <div className="author">
                                        {getAuthors(book.book.author_name)}
                                    </div>
                                    <div className="first-published">
                                        {book.book.first_publish_year}
                                    </div>
                                    {(book.book.subject?.length > 0 || editMode) &&
                                        <div className="categories">
                                            {editMode ?
                                                <>
                                                    <div className="update-categories-label">
                                                        Update this book's categories
                                                    </div>
                                                    <Chips value={bookModalEditModeSubjects}
                                                           className="edit-categories"
                                                           onChange={(event) => {
                                                               book.book.subject = event.value;
                                                               setBookModalEditModeSubjects(book.book.subject);
                                                           }}
                                                    />
                                                </>
                                                :
                                                <>
                                                    {book.book.subject.map((category, index) => {
                                                        return (
                                                            <Chip key={index} label={category}
                                                                  className="category-chip"/>
                                                        );
                                                    })}
                                                </>
                                            }

                                        </div>
                                    }

                                    {editMode &&
                                        <div className="upload-new-image">

                                            <div className="upload-new-image-label">
                                                Upload a new cover image
                                            </div>

                                            <FileUpload mode="advanced" name="book-cover-uploader"
                                                        className="book-cover-uploader"
                                                        accept="image/*"
                                                        chooseLabel={<FontAwesomeIcon icon="upload"/>}
                                                        customUpload
                                                        onSelect={(event) => {
                                                            let file = event.files[0];
                                                            if (file.size > 1000000) {
                                                                alert("File size is too large. Please upload an image less than 1MB.");
                                                            } else {
                                                                let reader = new FileReader();
                                                                reader.onloadend = () => {
                                                                    book.tempCoverData = reader.result;
                                                                }
                                                                reader.readAsDataURL(file);
                                                            }
                                                        }}
                                                        uploadHandler={(event) => {
                                                            // clear the file input
                                                            event.files = [];
                                                        }}
                                            />

                                        </div>
                                    }

                                </div>
                            </div>

                            <div className="update-actions">
                                {!editMode &&
                                    <Fade in={showUpdateButtons()}>
                                        <>
                                            {(!isReading(book) && !hasCompleted(book)) &&
                                                <Fab
                                                    variant="extended"
                                                    size="small"
                                                    className="mark-as-reading fab"
                                                    onClick={() => {
                                                        markAsReading(book.book);
                                                        setBookModalNavValue("details");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon="book-open"/>
                                                    <span>Reading</span>
                                                </Fab>
                                            }

                                            {(isReading(book) || hasCompleted(book)) &&
                                                <Fab
                                                    variant="extended"
                                                    size="small"
                                                    className="mark-as-unread fab"
                                                    onClick={() => {
                                                        markAsNotReading(book.book);
                                                        setBookModalNavValue("details");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon="book"/>
                                                    {isReading(book) && <span>Not Reading</span>}
                                                    {hasCompleted(book) && <span>Not Completed</span>}
                                                </Fab>
                                            }

                                            {!hasCompleted(book) &&
                                                <Fab
                                                    variant="extended"
                                                    size="small"
                                                    className="mark-as-completed fab"
                                                    onClick={() => {
                                                        markCompleted(book.book);
                                                        setBookModalNavValue("details");
                                                    }}
                                                >
                                                    <FontAwesomeIcon icon="check"/>
                                                    <span>Completed</span>
                                                </Fab>
                                            }
                                        </>
                                    </Fade>
                                }
                            </div>

                            {!editMode &&
                                <div className="book-actions">
                                    <BottomNavigation value={bookModalNavValue} onChange={(event, newValue) => {
                                        if (bookModalNavValue === "update") {
                                            setBookModalNavValue("details");
                                        } else {
                                            setBookModalNavValue(newValue);
                                        }
                                    }}>
                                        <BottomNavigationAction
                                            label="Update"
                                            value="update"
                                            icon={<FontAwesomeIcon icon="bars"/>}
                                        />
                                        <BottomNavigationAction
                                            className="delete-book-button"
                                            label=""
                                            value="delete"
                                            icon={<FontAwesomeIcon icon="trash"/>}
                                            onClick={(event) => {
                                                openConfirmDialog(book.book, event)
                                            }}
                                        />
                                    </BottomNavigation>
                                </div>
                            }

                        </>
                    }
                </div>
            </Modal>
        );
    }

}


export default BookModal;
